<template>
  <div>
    <bar-manut single-entity="Manifestação de Nota Recebida" plural-entity="Manifestação de Nota Recebida" :crud="this.crud"
      :btn-delete="false" :moreActions="getActionsManifesto()" @action="handleAction" @closeform="closeForm">
    </bar-manut>

    <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
    <div class="default-container">
      <div>
        <div class="row">
          <div class="col-3" style="float: left">
            <v-label label="Manifestação"></v-label><br>
            <strong class="lbl">{{ statusManifesto(manifesto.confdest) }}</strong>
          </div>
          <div class="col-3" style="float: left">
            <v-label :label="metadata.manifesto.nrdoc.label"></v-label><br>
            <strong class="lbl">{{ manifesto.nrdoc }}</strong>
          </div>
          <div class="col-3" style="float: left">
            <v-label :label="metadata.manifesto.vnf.label"></v-label><br>
            <strong class="lbl">{{ manifesto.vnf | formatValue(2) }}</strong>
          </div>
          <div class="col-3" style="float: left">
            <v-label :label="metadata.manifesto.dtdoc.label"></v-label><br>
            <strong class="lbl">{{ manifesto.dtdoc | formatData }}</strong>
          </div>
          <div class="col-6" style="float: left">
            <v-label :label="metadata.manifesto.emi_nome.label"></v-label><br>
            <strong class="lbl">{{ manifesto.emi_nome }}</strong>
          </div>
          <div class="col-6" style="float: left">
            <v-label :label="metadata.manifesto.chnfe.label"></v-label><br>
            <strong class="lbl">{{ manifesto.chnfe }}</strong>
          </div>
          <div class="col-6" style="float: left">
            <v-label :label="metadata.manifesto.emi_cnpjcpf.label"></v-label><br>
            <strong class="lbl">{{ manifesto.emi_cnpjcpf | formatCNPJCPF }}</strong>
          </div>
        </div>
        <br>

        <div class="default-container">
          <div class="mainbox" v-for="item in manifesto.list_manifesto" v-bind:key="manifesto.codmanifesto">
            <div class="box">
              <div class="row">
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> Tipo </label><span class="data-list">{{ statusManifesto(item.confdest) }}
                  </span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list"> {{ metadata.manifesto.tpevento.label }} </label><span class="data-list">{{
                    descricaoEvento(item.tpevento) }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.dataleitura.label }} </label>
                  <span class="data-list">{{ item.dataleitura | formatData }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.dtemi.label }} </label><span class="data-list">{{ item.dtemi | formatData }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.stnfedesc.label }} </label><span class="data-list">{{ item.stnfedesc }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.tpamb.label }} </label><span class="data-list">{{ item.tpamb }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.tpnf.label }} </label>
                  <span class="data-list">{{ item.tpnf }}</span>
                </div>
                <div class="col-md-3 col-6" style="float: left">
                  <label class="lbl-list w-100"> NSU </label>
                  <span class="data-list">{{ item.nsu_novows }}</span>
                </div>
                <div class="col-12" v-if="item.msg">
                  <label class="lbl-list w-100"> {{ metadata.manifesto.msg.label }} </label>
                  <span class="data-list">{{ item.msg }} </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- BARRA FIXA DE BOTOES INFERIOR -->
    <div class="w-100 text-center"
      style="position: fixed; left: 0; bottom: 0; z-index: 10; border-top: 1px solid #eee; background-color: #fdfbfb; padding: 15px; -webkit-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); -moz-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); box-shadow: 0 -2px 5px rgba(0,0,0,0.2);">
      <v-button label="Ciência da Operação" icon="" title="" v-if="manifesto.confdest == '0'" :nb-btdef="false"
        @click="handleAction(Actions.CIENCIA_OPERACAO)"></v-button>
      <v-button label="Confirmação da Operação" icon="" v-if="manifesto.confdest == '0'" :nb-btdef="false"
        @click="handleAction(Actions.CONFIRMACAO_OPERACAO)"></v-button>
      <v-button label="Desconhecimento da Operação" icon="" v-if="manifesto.confdest == '0'" :nb-btdef="false"
        @click="handleAction(Actions.DESCONHECIMENTO_OPERACAO)"></v-button>
      <v-button label="Operação não realizada" icon="" v-if="manifesto.confdest == '0'" :nb-btdef="false"
        @click="handleAction(Actions.OPERACAO_NAO_REALIZADA)"></v-button>
      <v-button label="Download do XML" icon=""
        v-if="manifesto.confdest != '0' && (!manifesto.list_manifesto[0].xml || manifesto.list_manifesto[0].xml == '')"
        :nb-btdef="true" @click="handleAction(Actions.CARREGAR_XML)"></v-button>
      <v-button label="Gerar NF de Entrada por XML" icon=""
        v-if="manifesto.list_manifesto[0].xml && manifesto.list_manifesto[0].xml != ''" :nb-btdef="true"
        @click="handleAction(Actions.GERAR_NF_ENTRADA)"></v-button>
      <v-button label="Download XML" icon=""
        v-if="manifesto.list_manifesto[0].xml && manifesto.list_manifesto[0].xml != ''" :nb-btdef="false"
        @click="handleAction(Actions.DOWNLOAD_XML)"></v-button>
    </div>
    <!-- FIM BARRA FIXA DE BOTOES INFERIOR -->

  </div>
</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, urlORDS } from '../shared/api-functions'
import apiManifesto from '../api/api-manifesto'

const Actions = {
  CIENCIA_OPERACAO: 0,
  CONFIRMACAO_OPERACAO: 1,
  DESCONHECIMENTO_OPERACAO: 2,
  OPERACAO_NAO_REALIZADA: 3,
  CARREGAR_XML: 4,
  GERAR_NF_ENTRADA: 5,
  DOWNLOAD_XML: 6
}


export default {
  props: {
    index: '',
    crud: '',
  },

  data() {
    return {
      Actions,
      crudText: '',
      showInfXml: false,
      manifesto: { ...this.$store.getters.getEntities.manifesto },
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
    }
  },

  mixins: [apiManifesto],

  computed: {
    editing: function () {
      return this.crud == SysVars.crudU
    },

    isView: function () {
      return (this.crud == SysVars.crudView)
    },

  },

  methods: {

    statusManifesto(confdest) {
      let statusmanifesto = confdest + ' - Sem Manifestação do Destinatário';
      if (confdest == '0') {
        statusmanifesto = confdest + ' - Sem Manifestação do Destinatário'
      }
      if (confdest == '1') {
        statusmanifesto = confdest + ' - Confirmada Operação'
      }
      if (confdest == '2') {
        statusmanifesto = confdest + ' - Desconhecida'
      }
      if (confdest == '3') {
        statusmanifesto = confdest + ' - Operação não Realizada'
      }
      if (confdest == '4') {
        statusmanifesto = confdest + ' - Ciência'
      }
      return statusmanifesto;
    },

    getActionsManifesto() {
      var moreActions = []
      var act = { action: 0, label: 'Ciência da Operação' }
      moreActions.push(act)
      var act = { action: 1, label: 'Confirmação da Operação' }
      moreActions.push(act)
      var act = { action: 2, label: 'Desconhecimento da Operação' }
      moreActions.push(act)
      var act = { action: 3, label: 'Operação não realizada' }
      moreActions.push(act)
      return moreActions
    },


    getActions() {
      var moreActions = []
      var act = { action: this.Actions.CIENCIA_OPERACAO, label: 'Ciência da Operação' }
      moreActions.push(act)
      var act = { action: this.Actions.CONFIRMACAO_OPERACAO, label: 'Confirmação da Operação' }
      moreActions.push(act)
      var act = { action: this.Actions.DESCONHECIMENTO_OPERACAO, label: 'Desconhecimento da Operação' }
      moreActions.push(act)
      var act = { action: this.Actions.OPERACAO_NAO_REALIZADA, label: 'Operação não realizada' }
      moreActions.push(act)
      var act = { action: this.Actions.CARREGAR_XML, label: 'Carregar XML dos Servidores da Receita' }
      moreActions.push(act)
      var act = { action: this.Actions.GERAR_NF_ENTRADA, label: 'Gerar NF de Entrada por XML' }
      moreActions.push(act)
      var act = { action: this.Actions.DOWNLOAD_XML, label: 'Download XML' }
      moreActions.push(act)
      return moreActions
    },

    callbackManifesto(tipo, success, manifesto, codevento) {
      if (success) {
        this.loadData();
      }
    },

    async callbackManifestoConfirmacao(tipo, success, manifesto, codevento) {
      console.log('manifesto confirmacao: ')
      console.log(success)
      if (success) {
        await this.loadData()
        console.log('efetuar download de confirmacao')
        console.log(this.manifesto)
        //efetua o download apos a confirmacao da operacao
        this.Downloadxml(this.manifesto, this.callbackManifestoDownload)
      }
    },

    async callbackManifestoDownload(tipo, success, manifesto, codevento) {
      if (success) {
        await this.loadData();
        if (this.manifesto.xml) {
          this.$erpToastSuccess('Operação executada com sucesso.')
        } else {
          let msg = null;
          await this.manifesto.list_manifesto.map(m => {
            if (m.msg) {
              msg = m.msg
            }
          })
          this.$erpToastError('Mensagem Retorno servidor NFe: ' + msg)
        }
      }
    },


    async handleAction(act) {

      if (act == this.Actions.CIENCIA_OPERACAO) {
        //Ciência da Operação
        this.EnviarEvento(this.manifesto, '210210', 'Ciencia da Operacao', '', this.callbackManifesto);
      }
      if (act == this.Actions.CONFIRMACAO_OPERACAO) {
        //Confirmação da Operação
        this.EnviarEvento(this.manifesto, '210200', 'Confirmacao da Operacao', '', this.callbackManifestoConfirmacao);
      }
      if (act == this.Actions.DESCONHECIMENTO_OPERACAO) {
        //Desconhecimento da Operação
        this.EnviarEvento(this.manifesto, '210220', 'Desconhecimento da Operacao', '', this.callbackManifesto);
      }
      if (act == this.Actions.OPERACAO_NAO_REALIZADA) {
        //Operação não realizada
        let ljust = prompt("Digite a justificativa porque a operação não foi realizada:", "");
        if (ljust != null && ljust != "") {
          this.EnviarEvento(this.manifesto, '210240', 'Operacao nao Realizada', ljust, this.callbackManifesto);
        }
      }
      if (act == this.Actions.CARREGAR_XML) {
        this.Downloadxml(this.manifesto, this.callbackManifestoDownload);
      }
      if (act == this.Actions.GERAR_NF_ENTRADA) {
        this.handleGerarNFXML(this.manifesto);
      }
      if (act == this.Actions.DOWNLOAD_XML) {
        this.handleDownloadFile(this.manifesto);
      }
    },

    descricaoEvento(tpevento) {
      let status = tpevento;
      if (tpevento == '210210') {
        status = 'Ciencia da Operação'
      }
      if (tpevento == '210200') {
        status = 'Confirmação da Operação'
      }
      if (tpevento == '210220') {
        status = 'Desconhecimento da Operação'
      }
      if (tpevento == '210240') {
        status = 'Operação não Realizada'
      }
      return status;
    },


    closeForm() {
      this.$emit('closeform')
    },

    handleSave() {
      //BOTAO SALVAR
      // this.$validator.validateAll().then(isValid => {
      //     if (!isValid) {
      //         this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
      //     } else {
      //         this.apiPost()
      //     }
      // })
    },

    async loadData() {
      //carrega o registro para alteracao ou visualizacao
      await this.$store.dispatch('loadManifesto', { id: this.index })
      if (this.$store.getters.getManifesto) {
        this.manifesto = { ...this.$store.getters.getManifesto }
        let self = this
        this.manifesto.list_manifesto.map(m => {
          if (m.xml) {
            self.manifesto.xml = m.xml
          }
        })
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiPost() {
      //efetua a gravacao

      var modulo = 'manifesto/pesquisar/'
      var sendData = {}

      sendData = { manifesto: this.manifesto }

      let metodo = 'post'
      let update = false
      if (this.crud != SysVars.crudI) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        if (update) {
          this.$erpToastUpdated()
        } else {
          this.$erpToastInserted()
        }
        this.errmessages = {}
        this.closeForm()
      }
    },

  },

  components: {
    Actions
  },

  beforeCreate() {

  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.crudText = this.$crudText(this.crud)

    if (this.crud == SysVars.crudI) {
    } else {
      this.loadData()
    }
  }

}

</script>

<style></style>



// WEBPACK FOOTER //
// src/forms/manifesto-form.vue